export default "__VITE_ASSET__DdMfUWoc__"